import { createContext } from 'react';

import type { Entitlements } from '../types';

export interface EntitlementsContextType {
  entitlements: Entitlements | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  hasEntitlements: boolean;
}

export const EntitlementsContext =
  createContext<EntitlementsContextType | null>(null);
